var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('div',{staticClass:"content"},[_c('div',{staticClass:"loading"},[_c('p',[_vm._v(_vm._s(_vm.isFetched.isError ? _vm.$t('errorMessage') : _vm.websiteName.short))]),_c('span')])])])}
var staticRenderFns = []

export { render, staticRenderFns }